import React from 'react';
import styled from './Logo.module.css';
import logo from '../../assets/images/logo.svg';

const Logo: React.FC = () => {
    return <img src={logo} alt="RAMBOLL" className={styled.Img} />;
};

export default Logo;
